module.exports = __webpack_public_path__ + "img/T2D_rc_14.05205640.png";